import React, { useState, useEffect, useReducer } from "react";
import { isEmpty } from "lodash";
import classnames from "classnames";
import Flatpickr from "react-flatpickr";
import
{
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  TabPane,
  TabContent,
  NavItem,
  NavLink,
  CardHeader,
  Nav,
  Spinner,
} from "reactstrap";
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import avatar from "../../../assets/images/users/user-dummy-img.jpg";
// actions
import { editProfile, resetProfileFlag } from "../../../store/actions";
import { Link, useHistory, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../axiosConfig";
import { lireRoleSession } from "../../../espace";

const AdminProfile = ( props ) =>
{
  const history = useHistory();
  const dispatch = useDispatch();
  const token = JSON.parse( localStorage.getItem( "authUser" ) )
    ? JSON.parse( localStorage.getItem( "authUser" ) ).accessToken
    : null;

  const [ authUser, setAuthUser ] = useState( [] );
  const [ id, setId ] = useState( "" );
  const [ userId, setUserId ] = useState( "" );
  const [ email, setEmail ] = useState( "" );
  const [ firstName, setFirstName ] = useState( "" );
  const [ pays, setPays ] = useState( "" );
  const [ lastName, setLastName ] = useState( "" );
  const [ activeTab, setActiveTab ] = useState( "1" );
  const [ loadingPersonalInfo, setLoadingPersonalInfo ] = useState( false );
  const [ loadingChangePassword, setLoadingChangePassword ] = useState( false );
  const [ loadingForgotPassword, setLoadingForgotPassword ] = useState( false );

  const [ roleSession, setRoleSession ] = useState( lireRoleSession )

  const [ showPassword, setShowPassword ] = useState( false );

  const [ inputLastName, setInputLastName ] = useState( lastName );
  const [ inputFirstName, setInputFirstName ] = useState( firstName );
  const [ inputEmailForgotPassword, setInputEmailForgotPassword ] =
    useState( email );

  const tabChange = ( tab ) =>
  {
    if ( activeTab !== tab ) setActiveTab( tab );
  };
  const [ reducerValue, forceUpdate ] = useReducer( ( x ) => x + 1, 0 );

  function handleClick ()
  {
    forceUpdate();
  }

  const { user, success, error } = useSelector( ( state ) => ( {
    user: state.Profile.user,
    success: state.Profile.success,
    error: state.Profile.error,
  } ) );

  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );

      if ( !isEmpty( user ) )
      {
        obj.data.first_name = user.first_name;
        localStorage.removeItem( "authUser" );
        localStorage.setItem( "authUser", JSON.stringify( obj ) );
      }

      setRoleSession( obj.role )

      // // console.log("obj: ", obj);
      setAuthUser( obj );
      setPays( obj.data.pays );
      setEmail( obj.data.email );
      setFirstName( obj.data.first_name );
      setLastName( obj.data.last_name );
      setId( obj.data.id );
      setUserId( obj.data.user_id );

      setTimeout( () =>
      {
        dispatch( resetProfileFlag() );
      }, 3000 );
    }
  }
  useEffect( () =>
  {
    getSessionData();
  }, [ dispatch, user ] );

  const validationPersonnalInfo = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      last_name: lastName || "Admin",
      first_name: firstName || "Admin",
      pays: pays || "Bénin",
      id: id || "",
    },
    validationSchema: Yup.object( {
      last_name: Yup.string().required( props.t( "Please Enter Your Last Name" ) ),
      first_name: Yup.string().required(
        props.t( "Please Enter Your First Name" )
      ),
      pays: Yup.string().required(
        props.t( "Veuillez saisir votre pays" )
      ),
    } ),

    onSubmit: ( values ) =>
    {
      // // console.log("Onsubmit Value: ", values);
      try
      {
        setLoadingPersonalInfo( true );

        const updateAdmin = {
          email: email,
          first_name: values.first_name,
          last_name: values.last_name,
        };

        // console.log( "updateAdmin: ", updateAdmin );

        try
        {
          if ( roleSession === "ORGANISATEUR" )
          {
            const updateAdmin = {
              email: email,
              first_name: values.first_name,
              pays: values.pays,
              last_name: values.last_name,
            };

            // console.log( "updateAdmin: ", updateAdmin );

            const data = axiosInstance
              .put( `/organisateurupdate/?id=${ userId }`, updateAdmin )
              .then( ( response ) =>
              {
                // // console.log("Response: ", response);
                // // console.log( "Obj first_name : ", authUser.data.first_name );
                // // console.log( "Obj last_name: ", authUser.data.last_name );

                authUser.data.last_name = values.last_name;
                authUser.data.first_name = values.first_name;

                // // console.log("new authUser: ", authUser);
                setAuthUser( authUser );

                localStorage.setItem( "authUser", JSON.stringify( authUser ) );
                getSessionData();

                // dispatch(onUpdateAdmin(updateAdmin));
                validationPersonnalInfo.resetForm();
                toast.success( props.t( "Organisateur modifié avec succès" ), {
                  autoClose: 3000,
                } );
                // dispatch( onGetAdmins() );
                handleClick();
                // setTimeout( () =>
                // {
                setLoadingPersonalInfo( false );
                // }, 100 );
              } )
              .catch( ( error ) =>
              {
                setTimeout( () =>
                {
                  setLoadingPersonalInfo( false );
                }, 100 );
                console.error( "Echec de la modification de l'Organisateur: ", error );
                toast.error( props.t( "Echec de la modification de l'Organisateur" ), {
                  autoClose: 3000,
                } );
              } );
          } else
          {
            const updateAdmin = {
              email: email,
              first_name: values.first_name,
              last_name: values.last_name,
            };

            // console.log( "updateAdmin: ", updateAdmin );

            const data = axiosInstance
              .put( `/admininfoupdate`, updateAdmin )
              .then( ( response ) =>
              {
                // // console.log("Response: ", response);
                // // console.log( "Obj first_name : ", authUser.data.first_name );
                // // console.log( "Obj last_name: ", authUser.data.last_name );

                authUser.data.last_name = values.last_name;
                authUser.data.first_name = values.first_name;

                // // console.log("new authUser: ", authUser);
                setAuthUser( authUser );

                localStorage.setItem( "authUser", JSON.stringify( authUser ) );
                getSessionData();

                // dispatch(onUpdateAdmin(updateAdmin));
                validationPersonnalInfo.resetForm();
                toast.success( props.t( "Admin successfully modified" ), {
                  autoClose: 3000,
                } );
                // dispatch( onGetAdmins() );
                handleClick();
                // setTimeout( () =>
                // {
                setLoadingPersonalInfo( false );
                // }, 100 );
              } )
              .catch( ( error ) =>
              {
                setTimeout( () =>
                {
                  setLoadingPersonalInfo( false );
                }, 100 );
                console.error( "Echec de la modification du Admin: ", error );
                toast.error( props.t( "Admin modification failed" ), {
                  autoClose: 3000,
                } );
              } );
          }


          // window.location.reload(true);
        } catch ( err )
        {
          setTimeout( () =>
          {
            setLoadingPersonalInfo( false );
          }, 100 );

          console.error( "Echec de la modification de l'organisateur: ", err );
          toast.error( props.t( "Echec de la modification de l'organisateur" ), {
            autoClose: 2000,
          } );
        }
      } catch ( error )
      {
        console.error(
          "Erreur pendant la modification d'informations personnelles: ",
          error
        );

        setLoadingPersonalInfo( false );
      }
    },
  } );

  const validationChangePassword = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      old_password: "",
      new_password: "",
      confirm_new_password: "",
      id: id || "",
    },
    validationSchema: Yup.object( {
      old_password: Yup.string().required(
        props.t( "Please Enter Your Old Password" )
      ),
      new_password: Yup.string().required(
        props.t( "Please Enter Your New Password" )
      ),
      // confirm_new_password: Yup.string().required( props.t( "Password Confirmation failed" ) ),
      confirm_new_password: Yup.string()
        .oneOf(
          [ Yup.ref( "new_password" ), null ],
          props.t( "Password Confirmation failed" )
        )
        .required( props.t( "Please Confirm Your New Password" ) ),
    } ),

    onSubmit: ( values ) =>
    {
      // console.log( "Onsubmit Value: ", values );
      try
      {
        // const passwordUpdatedData = {
        //   old_password: values.old_password,
        //   new_password: values.new_password,
        // }
        const passwordUpdatedData = {
          AncienPassword: values.old_password,
          NouveauPassword: values.new_password,
        };

        // if ( roleSession === "ORGANISATEUR" )
        // { } else
        // {
        // }
        setLoadingChangePassword( true );
        // console.log( "Modification du mot de passe: ", passwordUpdatedData );

        // const urlUpdatePassword = "https://stepnode.inawo.pro/adminupdatepassword/"

        const data = axiosInstance
          .put( "/adminupdatepassword/", passwordUpdatedData, {
            headers: { Authorization: `Bearer ${ token }` },
          } )
          .then( ( response ) =>
          {
            // console.log( "Response: ", response );
            // dispatch(onUpdateAdmin(updateAdmin));
            validationChangePassword.resetForm();
            toast.success( props.t( "Password changed successfully" ), {
              autoClose: 3000,
            } );
            // dispatch( onGetAdmins() );
            handleClick();
            setTimeout( () =>
            {
              setLoadingChangePassword( false );
            }, 100 );
          } )
          .catch( ( error ) =>
          {
            setTimeout( () =>
            {
              setLoadingChangePassword( false );
            }, 100 );
            console.error( "Echec de la modification du mot de passe: ", error );
            toast.error( props.t( "Password change failed" ), { autoClose: 3000 } );
          } );

        setTimeout( () =>
        {
          setLoadingChangePassword( false );
        }, 500 );
      } catch ( error )
      {
        console.error(
          "Erreur pendant la modification de mot de passe: ",
          error
        );

        setLoadingChangePassword( false );
      }
    },
  } );

  const resetPassword = ( e ) =>
  {
    e.preventDefault();
    setLoadingForgotPassword( true );
    const resetdata = {
      email: email,
    };

    // console.log( "Réinitialisation du mot de passe: ", resetdata );
    try
    {
      const data = axiosInstance
        .post( "/requestPasswordReset/", resetdata )
        .then( ( res ) =>
        {
          // console.log( "res: ", res );
          toast.success( props.t( "Reset link sent" ), { autoClose: 3000 } );
          setTimeout( () =>
          {
            setLoadingForgotPassword( false );
            history.push( "/logout" );
          }, 500 );
        } )
        .catch( ( error ) =>
        {
          // console.log( error );
          toast.error( props.t( "Failed to send reset link" ), {
            autoClose: 3000,
          } );
          setLoadingForgotPassword( false );
        } );

      // console.log( "data: ", data );
    } catch ( error )
    {
      setTimeout( () =>
      {
        setLoadingForgotPassword( false );
      }, 500 );

      // console.log( "Erreur lors de réinitialisation du mot de passe: ", error );
      toast.error( props.t( "Failed to send reset link" ), { autoClose: 2000 } );
    }
  };

  document.title = `Profil ${ firstName } ${ lastName } |  Takci - Admin`;
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="12">
              {/* {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">Username Updated To {userName}</Alert> : null} */}

              <Card
                className="shadow-lg"
                style={ { borderLeft: "5px solid #01064a" } }
              >
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3">
                      <img
                        src={ avatar }
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h3 className="fw-bolder" style={ { color: "#01064a" } }>
                          { `${ firstName } ${ lastName }` || "Admin" }
                        </h3>
                        <p className="mb-1">Email: { email }</p>
                        <p className="mb-0">Id No : #{ id }</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <Card>
                <CardHeader>
                  <Nav
                    className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        to="#"
                        type="button"
                        className={ classnames( { active: activeTab === "1" } ) }
                        onClick={ () =>
                        {
                          tabChange( "1" );
                        } }
                      >
                        <i className="fas fa-user"></i>
                        { props.t( "Personal details" ) }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={ classnames( { active: activeTab === "2" } ) }
                        onClick={ () =>
                        {
                          tabChange( "2" );
                        } }
                        type="button"
                      >
                        <i className="far fa-lock"></i>
                        { props.t( "Change Password" ) }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={ classnames( { active: activeTab === "3" } ) }
                        onClick={ () =>
                        {
                          tabChange( "3" );
                        } }
                        type="button"
                      >
                        <i className="far fa-shield-fill-exclamation"></i>
                        { props.t( "Forgot Password" ) }
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>

                <CardBody className="p-4">
                  <TabContent activeTab={ activeTab }>
                    {/* Informations personnelles */ }
                    <TabPane tabId="1">
                      <Form
                        onSubmit={ ( e ) =>
                        {
                          e.preventDefault();
                          validationPersonnalInfo.handleSubmit();
                          return false;
                        } }
                      >
                        <Row>
                          <Col lg={ 6 }>
                            <div className="mb-3">
                              <Label
                                htmlFor="last_name-admin"
                                className="form-label"
                              >
                                { props.t( "Last Name" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                name="last_name"
                                id="last_name-admin"
                                className="form-control"
                                placeholder={ props.t( "Enter Your Last Name" ) }
                                type="text"
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validationPersonnalInfo.handleChange }
                                onBlur={ validationPersonnalInfo.handleBlur }
                                value={
                                  validationPersonnalInfo.values.last_name || ""
                                }
                                invalid={
                                  validationPersonnalInfo.touched.last_name &&
                                    validationPersonnalInfo.errors.last_name
                                    ? true
                                    : false
                                }
                              />
                              { validationPersonnalInfo.touched.last_name &&
                                validationPersonnalInfo.errors.last_name ? (
                                <FormFeedback type="invalid">
                                  { validationPersonnalInfo.errors.last_name }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>
                          <Col lg={ 6 }>
                            <div className="mb-3">
                              <Label
                                htmlFor="first_name-admin"
                                className="form-label"
                              >
                                { props.t( "First Name" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                name="first_name"
                                id="first_name-admin"
                                className="form-control"
                                placeholder={ props.t( "Enter Your First Name" ) }
                                type="text"
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validationPersonnalInfo.handleChange }
                                onBlur={ validationPersonnalInfo.handleBlur }
                                value={
                                  validationPersonnalInfo.values.first_name ||
                                  ""
                                }
                                invalid={
                                  validationPersonnalInfo.touched.first_name &&
                                    validationPersonnalInfo.errors.first_name
                                    ? true
                                    : false
                                }
                              />
                              { validationPersonnalInfo.touched.first_name &&
                                validationPersonnalInfo.errors.first_name ? (
                                <FormFeedback type="invalid">
                                  { validationPersonnalInfo.errors.first_name }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>

                          <Col lg={ 6 }>
                            <div className="mb-3">
                              <Label
                                htmlFor="first_name-admin"
                                className="form-label"
                              >
                                { props.t( "Pays" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                name="pays"
                                id="pays-admin"
                                className="form-control"
                                placeholder={ props.t( "Veuillez entrer votre pays" ) }
                                type="text"
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validationPersonnalInfo.handleChange }
                                onBlur={ validationPersonnalInfo.handleBlur }
                                value={
                                  validationPersonnalInfo.values.pays ||
                                  ""
                                }
                                invalid={
                                  validationPersonnalInfo.touched.pays &&
                                    validationPersonnalInfo.errors.pays
                                    ? true
                                    : false
                                }
                              />
                              { validationPersonnalInfo.touched.pays &&
                                validationPersonnalInfo.errors.pays ? (
                                <FormFeedback type="invalid">
                                  { validationPersonnalInfo.errors.pays }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>

                          <Col lg={ 12 }>
                            <div className="hstack gap-2 justify-content-center">
                              {/* <button type="button" className="btn btn-primary">
                                  {props.t("Modifier")}
                                </button> */}
                              <Button
                                disabled={ loadingPersonalInfo ? true : false }
                                style={ { backgroundColor: "#01064a" } }
                                className="btn text-white"
                                type="submit"
                              >
                                { loadingPersonalInfo ? (
                                  <Spinner size="sm" className="me-2">
                                    { " " }
                                    { props.t( "edition" ) }...{ " " }
                                  </Spinner>
                                ) : null }
                                { props.t( "Edit" ) +
                                  " " +
                                  props.t( "Personal details" ) }
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </TabPane>
                    {/* Informations personnelles */ }

                    {/* Changement de mot de passe */ }
                    <TabPane tabId="2">
                      <Form
                        onSubmit={ ( e ) =>
                        {
                          e.preventDefault();
                          validationChangePassword.handleSubmit();
                          return false;
                        } }
                      >
                        <Row className="g-2">
                          <Col lg={ 4 }>
                            <div className="mb-3">
                              <Label
                                htmlFor="old-password-admin"
                                className="form-label"
                              >
                                { props.t( "Old Password" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <div className="position-relative auth-pass-inputgroup mb-3">
                                <Input
                                  type={ showPassword ? "text" : "password" }
                                  name="old_password"
                                  id="old_password"
                                  className="form-control"
                                  placeholder={ props.t(
                                    "Enter Your Old Password"
                                  ) }
                                  validate={ {
                                    required: { value: true },
                                  } }
                                  onChange={
                                    validationChangePassword.handleChange
                                  }
                                  onBlur={ validationChangePassword.handleBlur }
                                  value={
                                    validationChangePassword.values.old_password
                                  }
                                  invalid={
                                    validationChangePassword.touched
                                      .old_password &&
                                      validationChangePassword.errors.old_password
                                      ? true
                                      : false
                                  }
                                />

                                { validationChangePassword.touched
                                  .old_password &&
                                  validationChangePassword.errors.old_password ? (
                                  <FormFeedback type="invalid">
                                    {
                                      validationChangePassword.errors
                                        .old_password
                                    }
                                  </FormFeedback>
                                ) : null }
                              </div>
                            </div>
                          </Col>

                          <Col lg={ 4 }>
                            <div className="mb-3">
                              <Label
                                htmlFor="new-password-admin"
                                className="form-label"
                              >
                                { props.t( "New Password" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <div className="position-relative auth-pass-inputgroup mb-3">
                                <Input
                                  type={ showPassword ? "text" : "password" }
                                  name="new_password"
                                  id="new_password"
                                  className="form-control"
                                  placeholder={ props.t(
                                    "Enter Your New Password"
                                  ) }
                                  validate={ {
                                    required: { value: true },
                                  } }
                                  onChange={
                                    validationChangePassword.handleChange
                                  }
                                  onBlur={ validationChangePassword.handleBlur }
                                  value={
                                    validationChangePassword.values.new_password
                                  }
                                  invalid={
                                    validationChangePassword.touched
                                      .new_password &&
                                      validationChangePassword.errors.new_password
                                      ? true
                                      : false
                                  }
                                />
                                { validationChangePassword.touched
                                  .new_password &&
                                  validationChangePassword.errors.new_password ? (
                                  <FormFeedback type="invalid">
                                    {
                                      validationChangePassword.errors
                                        .new_password
                                    }
                                  </FormFeedback>
                                ) : null }
                              </div>
                            </div>
                          </Col>

                          <Col lg={ 4 }>
                            <div className="mb-3">
                              <Label
                                htmlFor="confirm-new-password-admin"
                                className="form-label"
                              >
                                { props.t( "Confirm New Password" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <div className="position-relative auth-pass-inputgroup mb-3">
                                <Input
                                  type={ showPassword ? "text" : "password" }
                                  name="confirm_new_password"
                                  id="confirm_new_password"
                                  className="form-control"
                                  placeholder={ props.t(
                                    "Confirm Your New Password"
                                  ) }
                                  validate={ {
                                    required: { value: true },
                                  } }
                                  onChange={
                                    validationChangePassword.handleChange
                                  }
                                  onBlur={ validationChangePassword.handleBlur }
                                  value={
                                    validationChangePassword.values
                                      .confirm_new_password
                                  }
                                  invalid={
                                    validationChangePassword.touched
                                      .confirm_new_password &&
                                      validationChangePassword.errors
                                        .confirm_new_password
                                      ? true
                                      : false
                                  }
                                />
                                { validationChangePassword.touched
                                  .confirm_new_password &&
                                  validationChangePassword.errors
                                    .confirm_new_password ? (
                                  <FormFeedback type="invalid">
                                    {
                                      validationChangePassword.errors
                                        .confirm_new_password
                                    }
                                  </FormFeedback>
                                ) : null }
                              </div>
                            </div>
                          </Col>

                          <Col lg={ 12 }>
                            <div className="form-check mb-3">
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="show-remember-check"
                                onChange={ () => setShowPassword( !showPassword ) }
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="show-remember-check"
                              >
                                { showPassword
                                  ? props.t( "Hide password" )
                                  : props.t( "Show password" ) }
                              </Label>
                            </div>
                          </Col>

                          <Col lg={ 12 }>
                            <div className="mb-3 text-end">
                              <Link
                                to="#"
                                onClick={ () =>
                                {
                                  tabChange( "3" );
                                } }
                                className="link-primary text-decoration-underline"
                              >
                                { props.t( "Forgot Password" ) } ?
                              </Link>
                            </div>
                          </Col>

                          <Col lg={ 12 }>
                            <div className="text-center">
                              <Button
                                disabled={ loadingChangePassword ? true : false }
                                style={ { backgroundColor: "#01064a" } }
                                className="btn text-white"
                                type="submit"
                              >
                                { loadingChangePassword ? (
                                  <Spinner size="sm" className="me-2">
                                    { " " }
                                    { props.t( "loading" ) }...{ " " }
                                  </Spinner>
                                ) : null }
                                { props.t( "Change Password" ) }
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </TabPane>
                    {/* Changement de mot de passe */ }

                    {/* Mot de passe oublié */ }
                    <TabPane tabId="3">
                      <Row>
                        <Col lg={ 12 }>
                          <Alert
                            className="alert-borderless alert-warning text-center mb-2 mx-2"
                            role="alert"
                          >
                            { props.t(
                              "Enter your e-mail address and instructions will be sent to you"
                            ) }
                            .
                          </Alert>

                          <div className="mb-3">
                            <Label htmlFor="email-admin" className="form-label">
                              { props.t( "Email" ) }{ " " }
                              <span style={ { color: "red" } }>*</span>
                            </Label>
                            <Input
                              name="email"
                              id="email-admin"
                              className="form-control"
                              placeholder={ props.t( "Enter Your Email" ) }
                              type="text"
                              validate={ {
                                required: { value: true },
                              } }
                              readOnly={ true }
                              value={ email }
                            />
                            {/* { validation.touched.email_forgot_password && validation.errors.email_forgot_password ? (
                              <FormFeedback type="invalid">{ validation.errors.email_forgot_password }</FormFeedback>
                            ) : null } */}
                          </div>
                        </Col>
                        <Col lg={ 12 }>
                          <div className="hstack gap-2 justify-content-center">
                            <Button
                              disabled={
                                loadingForgotPassword && email.length > 0
                                  ? true
                                  : false
                              }
                              style={ { backgroundColor: "#01064a" } }
                              className="btn text-white"
                              type="submit"
                              onClick={ resetPassword }
                            >
                              { loadingForgotPassword ? (
                                <Spinner size="sm" className="me-2">
                                  { " " }
                                  { props.t( "loading" ) }...{ " " }
                                </Spinner>
                              ) : null }
                              { props.t( "Send reset link" ) }
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    {/* Mot de passe oublié */ }
                  </TabContent>
                  <ToastContainer closeButton={ false } />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

AdminProfile.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter( withTranslation()( AdminProfile ) );
